"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var withContext_1 = require("../../utils/hoc/withContext");
var UnmanagedTooltipIconWithinContext_1 = require("./UnmanagedTooltipIconWithinContext");
/**
 * This is the unmanaged variant of the [TooltipIcon](#!/TooltipIcon) component.
 *
 * The `TooltipIcon` component manages the open state.
 * If you want to control the open state yourself, you can use this component.
 *
 * To do so the callback handler `onToggleOpen` has to be set as property.
 * This handler is called when the user clicks on the icon, the close button
 * in the tooltip or an element outside of the tooltip.
 * The handler should set the property `isOpen` to the desired value.
 */
exports.UnmanagedTooltipIcon = withContext_1.withErgoElementsContext('UnmanagedTooltipIcon', UnmanagedTooltipIconWithinContext_1.UnmanagedTooltipIconWithinContext);
exports.default = exports.UnmanagedTooltipIcon;
__export(require("./UnmanagedTooltipIconWithinContext"));
//# sourceMappingURL=UnmanagedTooltipIcon.js.map